export default function PostNew() {
    return <h1>Post New Page</h1>;
}
